import React, { useMemo, useState } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import DateTimePickerModal from 'react-native-modal-datetime-picker';
import moment from 'moment';
import styles from './styles';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

type DatePickerProps = {
  label: string;
  name: string;
};

const DatePickerField = ({ label, name }: DatePickerProps) => {
  const { setFieldValue, handleBlur, touched, errors, values } =
    useFormikContext();

  const isTouched = useMemo(() => {
    return get(touched, name);
  }, [touched, name]);

  const value = useMemo(() => {
    return get(values, name);
  }, [values, name]);

  const error = useMemo(() => {
    return get(errors, name);
  }, [errors, name]);

  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);
  const [dateString, setDateString] = useState<any>(null);
  const [date, setDate] = useState(new Date());

  const showDatePicker = () => {
    setDatePickerVisibility(true);
  };

  const hideDatePicker = () => {
    setDatePickerVisibility(false);
  };

  const handleConfirm = (pickerDate: any) => {
    const beautyDate = moment(date).format('DD/MM/YYYY');
    setDateString(beautyDate);
    setDate(pickerDate);
    hideDatePicker();
    setFieldValue(name, beautyDate);
  };
  return (
    <View style={[styles.dateContainer]}>
      <Text style={[styles.labelStyle]}>{label}</Text>
      <TouchableOpacity
        onBlur={() => handleBlur(name)}
        onPress={showDatePicker}
        style={styles.dateInputContainer}
      >
        <View style={styles.dateValueContainer}>
          {!value ? (
            <>
              <Text style={styles.textDate}>DD</Text>
              <Text style={styles.splashDate}>/</Text>
              <Text style={styles.textDate}>MM</Text>
              <Text style={styles.splashDate}>/</Text>
              <Text style={styles.textDate}>YY</Text>
            </>
          ) : (
            <Text style={styles.dateValue}>{String(dateString)}</Text>
          )}
        </View>
      </TouchableOpacity>
      {isTouched && error && <Text style={styles.error}>{error}</Text>}
      <DateTimePickerModal
        isVisible={isDatePickerVisible}
        mode="date"
        date={date}
        onConfirm={handleConfirm}
        onCancel={hideDatePicker}
      />
    </View>
  );
};

export default DatePickerField;
